import { faChevronDown, faChevronUp, faUserSecret, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useStopImpersonation } from '@modules/Clients/List/hooks/useImpersonate';
import { useAuthStore } from '@shared/stores/authStore';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../button';

export const ImpersonationBanner = () => {
    const { isImpersonating, user, team } = useAuthStore();
    const stopImpersonation = useStopImpersonation();
    const { t } = useTranslation('clientsModule');
    const [isExpanded, setIsExpanded] = useState(false);

    // No mostrar el banner si no se está impersonando
    if (!isImpersonating) {
        return null;
    }

    const handleStopImpersonation = () => {
        stopImpersonation.mutate();
    };

    return (
        <div className="fixed bottom-4 right-4 z-50 transition-all duration-300">
            {/* Versión colapsada - Badge flotante */}
            {!isExpanded && (
                <div
                    onClick={() => setIsExpanded(true)}
                    className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-amber-500 to-amber-400 rounded-full shadow-lg cursor-pointer hover:shadow-xl transition-all hover:scale-105"
                >
                    <div className="flex items-center justify-center w-6 h-6 bg-amber-600 rounded-full">
                        <FontAwesomeIcon
                            icon={faUserSecret}
                            className="text-white text-xs"
                        />
                    </div>
                    <span className="text-xs font-semibold text-white">
                        Impersonando
                    </span>
                    <FontAwesomeIcon
                        icon={faChevronUp}
                        className="text-white text-xs"
                    />
                </div>
            )}

            {/* Versión expandida - Card completo */}
            {isExpanded && (
                <div className="bg-card-bg border border-amber-500 rounded-lg shadow-2xl w-80 animate-in slide-in-from-bottom-2">
                    {/* Header */}
                    <div className="bg-gradient-to-r from-amber-500 to-amber-400 px-4 py-3 rounded-t-lg">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2">
                                <div className="flex items-center justify-center w-8 h-8 bg-amber-600 rounded-full">
                                    <FontAwesomeIcon
                                        icon={faUserSecret}
                                        className="text-white text-sm"
                                    />
                                </div>
                                <span className="text-sm font-bold text-white">
                                    Modo Impersonación
                                </span>
                            </div>
                            <button
                                onClick={() => setIsExpanded(false)}
                                className="text-white hover:text-amber-900 transition-colors"
                            >
                                <FontAwesomeIcon icon={faChevronDown} />
                            </button>
                        </div>
                    </div>

                    {/* Contenido */}
                    <div className="p-4 space-y-3">
                        {/* Usuario */}
                        <div>
                            <p className="text-xs text-muted-foreground mb-1">Usuario:</p>
                            <p className="text-sm font-semibold text-title">{user?.name}</p>
                            <p className="text-xs text-complementary-text">{user?.email}</p>
                        </div>

                        {/* Cliente/Team */}
                        {team && (
                            <div>
                                <p className="text-xs text-muted-foreground mb-1">Cliente:</p>
                                <p className="text-sm font-semibold text-title">{team.name}</p>
                            </div>
                        )}

                        {/* Separador */}
                        <div className="border-t border-border"></div>

                        {/* Botón detener - siempre disponible cuando se está impersonando */}
                        <Button
                            variant="destructive"
                            size="sm"
                            onClick={handleStopImpersonation}
                            disabled={stopImpersonation.isPending}
                            className="w-full"
                        >
                            <FontAwesomeIcon icon={faXmark} className="mr-2" />
                            {stopImpersonation.isPending
                                ? t('impersonation.stopping')
                                : t('impersonation.stop')}
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
};
